import { render } from "./AIMLItsTestimonialComp.vue?vue&type=template&id=33f43238&scoped=true"
import script from "./AIMLItsTestimonialComp.vue?vue&type=script&lang=js"
export * from "./AIMLItsTestimonialComp.vue?vue&type=script&lang=js"

import "./AIMLItsTestimonialComp.vue?vue&type=style&index=0&id=33f43238&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f43238"]])

export default __exports__